import React, { useEffect, useRef, useState } from "react";
import "../styles/Home.css";
import Navbar from "../components/Navbar";
import scale from "../assets/images/scale.webp";
import NotePreview from "./NotePreview";
import { useNavigate } from "react-router-dom";
import emailjs from "emailjs-com";
import { onAuthStateChanged } from "firebase/auth";
import { auth } from "../firebase";
import { Helmet } from "react-helmet";


function Home() {
  //----------------------------------------------------------------------------------------------
  const [showContent, setShowContent] = useState(false);
  const [previewData, setPreviewData] = useState(null);
  const [userProfile, setUserProfile] = useState(null);
  const [currentUser, setCurrentUser] = useState(null);
  const [showProfileModal, setShowProfileModal] = useState(false);
  const [showUpdateNotice, setShowUpdateNotice] = useState(false);

  const openPreview = (subject, course, semester, fileName) => {
    setPreviewData({ subject, course, semester, fileName });
  };

  const closePreview = () => {
    setPreviewData(null);
  };

  const handleNavigate = (path) => {
    navigate(path);
    window.scrollTo({ top: 0, behavior: "auto" }); // scrolls to top immediately
  };

  const navigate = useNavigate();
  const isAibeProfile = userProfile?.course === "AIBE Preparation";
  const isProfileValid =
    userProfile?.name?.trim() &&
    userProfile?.course &&
    (userProfile.course === "AIBE Preparation" || userProfile?.year);

  const courseOptions = [
    { value: "BALLB", label: "BALLB 5YDC" },
    { value: "BBALLB", label: "BBALLB 5YDC" },
    { value: "BCOMLLB", label: "BCOMLLB 5YDC" },
    { value: "3YDC", label: "LLB 3YDC" },
    { value: "AIBE Preparation", label: "AIBE Preparation" },
  ];

  const handleAibePracticeNavigate = () => {
    if (currentUser) {
      handleNavigate("/aibe-preparation/practice");
      return;
    }
    navigate("/auth", { state: { from: { pathname: "/aibe-preparation/practice" } } });
  };

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, (user) => {
      setCurrentUser(user);
      if (user) {
        // User is logged in

        const storedProfile = localStorage.getItem("tejcodex_user");

        if (storedProfile) {
          setUserProfile(JSON.parse(storedProfile));
        } else {
          // Logged in BUT no profile saved
          setShowUpdateNotice(true);
        }
      } else {
        setUserProfile(null);
      }
    });

    return () => unsubscribe();
  }, []);
  //----------------------------------------------------------------------------------------------

  useEffect(() => {
    const timer = setTimeout(() => {
      setShowContent(true);
    }, 100); // show content after trapeziums finish sliding
    return () => clearTimeout(timer);
  }, []);
  //----------------------------------------------------------------------------------------------
  useEffect(() => {
    if (!showContent) return;

    const typSpd = 80;
    const waitTime = 1500;

    const text = [
      "⚖️ Law is reason free from passion. – Aristotle",
      "📚 A lawyer’s true power lies in knowledge. – Jeremy Bentham",
      "⌛ Justice delayed is justice denied. – Gladstone",
      "💡 Study the past to shape the future. – Confucius",
      "🖊️ Good law is good order. – Aristotle",
      "🎓 An investment in knowledge pays the best interest. – Franklin",
      "🔥 Discipline is the bridge between goals and success. – Jim Rohn",
      "📖 Knowledge matters only when applied. – Chekhov",
      "⚔️ True freedom requires rule of law and justice. – Narayana Murthy",
      "⚖️ Lawyers are the foot soldiers of the Constitution. – Strickland",
      "🚀 The future belongs to those who prepare today. – Malcolm X",
      "💪 Diligence is the mother of good fortune. – Cervantes",
      "🌍 Injustice anywhere is a threat to justice everywhere. – MLK Jr.",
      "📚 The life of the law has been experience, not logic. – Holmes Jr.",
    ];

    let mi = 0;

    function writeString(e, str, i) {
      e.innerHTML = e.innerHTML + str[i];

      // ✅ always delete after finishing, no stop condition
      if (e.innerHTML.length === str.length)
        setTimeout(slowlyDelete, waitTime, e);
    }

    function deleteString(e) {
      e.innerHTML = e.innerHTML.substring(0, e.innerHTML.length - 1);

      if (e.innerHTML.length === 0) {
        // ✅ cycle using modulo
        slowlyWrite(e, text[mi % text.length]);
        mi++;
      }
    }

    function slowlyDelete(e) {
      for (let i = 0; i < e.innerHTML.length; i++) {
        setTimeout(deleteString, (typSpd / 6) * i, e);
      }
    }

    function slowlyWrite(e, str) {
      for (let i = 0; i < str.length; i++) {
        setTimeout(writeString, typSpd * i, e, str, i);
      }
    }

    const msg = document.querySelector(".Hmsg-icn");
    if (msg) slowlyDelete(msg);
  }, [showContent]);

  //----------------------------------------------------------------------------------------------

  const [flipped, setFlipped] = useState([false, false, false]);

  const handleFlip = (index) => {
    setFlipped((prev) => prev.map((f, i) => (i === index ? !f : f)));
  };

  const books = [
    {
      title: "Syllabus",
      comment: "-For 3YDC & 5YDC LLB Law Courses",
      content: (
        <div className="syllabus-options">
          {/* Left Column - 3YDC */}
          <div className="syllabus-row">
            <h3>3YDC - Syllabus</h3>
            <button
              className="syllabus-btn"
              onClick={() =>
                openPreview(
                  "Syllabus",
                  "3YDC",
                  "",
                  "/Syllabus/3YDC/LLB3YDCOUSyllabus.html",
                )
              }
            >
              View
            </button>
          </div>

          {/* Right Column - 5YDC */}
          <div className="syllabus-row">
            <h3>5YDC - Syllabus</h3>
            <div className="syllabus-btn-group">
              <button
                className="syllabus-btn"
                onClick={() =>
                  openPreview(
                    "Syllabus",
                    "BALLB",
                    "",
                    "/Syllabus/BALLB/BALLBOUSyllabus.html",
                  )
                }
              >
                BALLB
              </button>
              <button
                className="syllabus-btn"
                onClick={() =>
                  openPreview(
                    "Syllabus",
                    "BBALLB",
                    "",
                    "/Syllabus/BBALLB/BBALLBOUSyllabus.html",
                  )
                }
              >
                BBALLB
              </button>
              <button
                className="syllabus-btn"
                onClick={() =>
                  openPreview(
                    "Syllabus",
                    "BCOMLLB",
                    "",
                    "/Syllabus/BCOMLLB/BCOMLLBOUSyllabus.html",
                  )
                }
              >
                BCOMLLB
              </button>
            </div>
          </div>
        </div>
      ),
    },
    {
      title: "Notes",
      comment: "-Semester and Subject wise Notes ",
      content: (
        <div className="notes-selection">
          <h2>Select your Course</h2>
          <div className="course-buttons">
            <button onClick={() => handleNavigate("/notes/5YDC")}>5YDC</button>
            <button onClick={() => handleNavigate("/notes/3YDC")}>3YDC</button>
            <button onClick={() => handleNavigate("/pyqs")}>PYQs</button>
          </div>
        </div>
      ),
    },
    {
      title: "AIBE",
      comment: "-Syllabus, Bare Acts and Practice",
      content: (
        <div className="notes-selection">
          <h2>AIBE Preparation</h2>
          <div className="course-buttons">
            <button onClick={() => handleNavigate("/aibe-preparation/syllabus")}>Syllabus</button>
            <button onClick={handleAibePracticeNavigate}>Practice</button>
          </div>
        </div>
      ),
    },
  ];

  //----------------------------------------------------------------------------------------------

  const blocks = Array.from({ length: 12 }, (_, i) => `Block ${i + 1}`);
  const block = [
    {
      heading: "📚 Organized Notes",
      statement:
        "All law notes arranged course-wise, semester-wise, and subject-wise.",
    },
    {
      heading: "⚖️ Complete Coverage",
      statement:
        "Covers both 3-Year and 5-Year LLB programs under OU syllabus.",
    },
    {
      heading: "📝 PYQs with Answers",
      statement:
        "Previous year question papers with simplified answers for quick prep.",
    },
    {
      heading: "🔍 Easy Search",
      statement:
        "Quickly find the notes or PYQs you need without wasting time.",
    },
    {
      heading: "🎯 Exam-Focused",
      statement:
        "Content designed to match exactly what’s needed for your exams.",
    },
    {
      heading: "🌐 Free Access",
      statement:
        "Every note and resource is available for free, anytime, anywhere.",
    },
    {
      heading: "📖 Simple Language",
      statement:
        "Notes are written in clear, easy-to-understand language.",
    },
    {
      heading: "🚀 Fast Loading",
      statement:
        "Lightweight design ensures smooth and quick access to notes.",
    },
    {
      heading: "🤝 Student-Friendly",
      statement:
        "Built exclusively for law students to study smarter, not harder.",
    },

    // AIBE FEATURES
    {
      heading: "⚖️ AIBE Preparation",
      statement:
        "Prepare for the AIBE with structured resources, syllabus guidance, Bare Acts, and practice support.",
    },
    {
      heading: "📚 AIBE Bare Acts",
      statement:
        "Access the essential Bare Act PDFs in one organized place for focused preparation.",
    },
    {
      heading: "📝 AIBE Practice Sessions",
      statement:
        "Practice with previous year paper-wise and random questions through interactive onscreen practice sessions.",
    },
  ];

  const statements = [
    "Law notes neatly structured for easier access...",
    "Covers both 3YDC & 5YDC LLB programs...",
    "Previous Year Questions with simplified answers...",
    "Find your notes faster with quick search...",
    "Content focused on exam needs...",
    "All resources available 100% free...",
    "Understand concepts in simple language...",
    "Quick load times for seamless study...",
    "Made by and for students of law...",
    "Complete AIBE preparation resources organized for focused examination preparation...",
    "AIBE syllabus and essential Bare Act PDFs organized for quick and convenient access...",
    "Practice AIBE questions through previous paper-wise, subject-wise, and random practice sessions...",
  ];
  const [activeIndex, setActiveIndex] = useState(0);
  const intervalRef = useRef(null);
  const galleryRef = useRef(null);
  const lastWheelTime = useRef(0);
  const containerRef = useRef(null); // already exists at the top of Features.js

  const touchStartX = useRef(0);
  const touchEndX = useRef(0);

  const prevSlide = () => {
    setActiveIndex((prev) => (prev - 1 + blocks.length) % blocks.length);
  };

  const nextSlide = () => {
    setActiveIndex((prev) => (prev + 1) % blocks.length);
  };

  const startAutoSlide = () => {
    if (!intervalRef.current) {
      intervalRef.current = setInterval(() => {
        nextSlide();
      }, 8000); // 10 seconds
    }
  };

  // Stop auto-slide
  const stopAutoSlide = () => {
    if (intervalRef.current) {
      clearInterval(intervalRef.current);
      intervalRef.current = null;
    }
  };

  useEffect(() => {
    startAutoSlide();
    return () => stopAutoSlide();
  }, []);

  // Handle mouse wheel scroll
  useEffect(() => {
    const gallery = galleryRef.current;
    if (!gallery) return;

    const handleWheel = (e) => {
      const now = Date.now();
      if (now - lastWheelTime.current < 500) return; // throttle 500ms
      lastWheelTime.current = now;

      if (e.deltaY > 0) {
        nextSlide();
      } else if (e.deltaY < 0) {
        prevSlide();
      }
    };

    gallery.addEventListener("wheel", handleWheel, { passive: true });
    return () => gallery.removeEventListener("wheel", handleWheel);
  }, []);

  // Touch drag/swipe
  useEffect(() => {
    const gallery = galleryRef.current;
    if (!gallery) return;

    const handleTouchStart = (e) => {
      touchStartX.current = e.touches[0].clientX;
    };

    const handleTouchMove = (e) => {
      touchEndX.current = e.touches[0].clientX;
    };

    const handleTouchEnd = () => {
      const distance = touchEndX.current - touchStartX.current;
      if (Math.abs(distance) > 50) {
        if (distance < 0) {
          nextSlide();
        } else {
          prevSlide();
        }
      }
    };

    gallery.addEventListener("touchstart", handleTouchStart);
    gallery.addEventListener("touchmove", handleTouchMove);
    gallery.addEventListener("touchend", handleTouchEnd);

    return () => {
      gallery.removeEventListener("touchstart", handleTouchStart);
      gallery.removeEventListener("touchmove", handleTouchMove);
      gallery.removeEventListener("touchend", handleTouchEnd);
    };
  }, []);

  useEffect(() => {
    const container = containerRef.current;
    if (!container) return;

    const disableScroll = (e) => {
      // prevent vertical scrolling inside gallery
      if (e.deltaY !== 0) {
        e.preventDefault();
      }
    };

    const handleMouseEnter = () => {
      container.addEventListener("wheel", disableScroll, { passive: false });
      container.classList.add("no-vertical-scroll");
    };

    const handleMouseLeave = () => {
      container.removeEventListener("wheel", disableScroll);
      container.classList.remove("no-vertical-scroll");
    };

    container.addEventListener("mouseenter", handleMouseEnter);
    container.addEventListener("mouseleave", handleMouseLeave);

    return () => {
      container.removeEventListener("mouseenter", handleMouseEnter);
      container.removeEventListener("mouseleave", handleMouseLeave);
      container.removeEventListener("wheel", disableScroll);
    };
  }, []);

  const getVisibleItems = () => {
    const prev = (activeIndex - 1 + blocks.length) % blocks.length;
    const next = (activeIndex + 1) % blocks.length;
    return [prev, activeIndex, next];
  };

  const visibleItems = getVisibleItems();

  //----------------------------------------------------------------------------------------------

  const courses = [
    {
      title: "3YDC",
      comment: "-Three Years Degree Course",
      path: "/notes", // target Notes page
      courseCode: "3YDC", // pass as state
      onClick: () => handleNavigate("/notes/3YDC"),
    },

    {
      title: "5YDC",
      comment: "-Five Years Degree Course",
      path: "/notes",
      courseCode: "5YDC",
      onClick: () => handleNavigate("/notes/5YDC"),
    },
  ];
  //----------------------------------------------------------------------------------------------

  const [formData, setFormData] = useState({
    name: "",
    email: "",
    message: "",
    time: new Date().toLocaleString(),
  });

  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);
  const [error, setError] = useState(false);

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setLoading(true);
    setSuccess(false);
    setError(false);

    const templateParams = {
      name: formData.name,
      email: formData.email,
      message: formData.message,
      time: new Date().toLocaleString(),
    };

    emailjs
      .send(
        "service_TejCodex",
        "template_9w26kov",
        templateParams,
        "-1wDk-Z48uDBTDyvr",
      )
      .then(
        () => {
          setLoading(false);
          setSuccess(true);
          setFormData({ name: "", email: "", message: "" });
        },
        () => {
          setLoading(false);
          setError(true);
        },
      );
  };

  useEffect(() => {
    let timer;
    if (success || error) {
      timer = setTimeout(() => {
        setSuccess(false);
        setError(false);
      }, 10000); // 10 seconds = 10000 ms
    }
    return () => clearTimeout(timer);
  }, [success, error]);

  //----------------------------------------------------------------------------------------------

  return (
    <div className="home">
      <Helmet>
        <title>TejCodex — Law Notes for 5YDC & 3YDC | OU Syllabus</title>
        <meta name="description" content="TejCodex provides free law notes, PYQs, and AIBE preparation resources including syllabus, Bare Acts, and practice questions for law students." />
        <link rel="canonical" href="https://tejcodex.com/" />
        <meta property="og:title" content="TejCodex — Free Law Notes for OU Students" />
        <meta property="og:description" content="Organized law notes, PYQs, and AIBE syllabus, Bare Acts, and practice resources for law students." />
        <meta property="og:url" content="https://tejcodex.com/" />
        <meta property="og:image" content="https://tejcodex.com/preview.webp" />
        <script type="application/ld+json">{JSON.stringify({
          "@context": "https://schema.org",
          "@graph": [
            {
              "@type": "WebSite",
              "@id": "https://tejcodex.com/#website",
              "url": "https://tejcodex.com",
              "name": "TejCodex",
              "description": "Free law notes, PYQs, and AIBE preparation resources for law students",
              "potentialAction": {
                "@type": "SearchAction",
                "target": "https://tejcodex.com/notes?q={search_term_string}",
                "query-input": "required name=search_term_string"
              }
            },
            {
              "@type": "Organization",
              "@id": "https://tejcodex.com/#organization",
              "name": "TejCodex",
              "url": "https://tejcodex.com",
              "logo": {
                "@type": "ImageObject",
                "url": "https://tejcodex.com/favicon-512x512.png"
              },
              "founder": {
                "@type": "Person",
                "name": "N. Tejeshwar"
              },
              "contactPoint": {
                "@type": "ContactPoint",
                "email": "tejcodex@gmail.com",
                "contactType": "customer support"
              }
            }
          ]
        })}</script>
      </Helmet>
      {!previewData && <Navbar />}
      <div className="welcome">🥇 Let’s Begin...</div>
      <section className="hero-section">
        <div className="trapezium trapezium-black"></div>
        <div className="trapezium trapezium-white"></div>

        {showContent && (
          <div className="content-layer">
            <div className="message">
              <h2> 👨‍🎓:: TejCodex ::👩‍🎓</h2>
              <div className="center">
                {userProfile ? (
                  <div className="personalized-hero">
                    <div className="hero-profile-header">
                      <h3 onClick={() => setShowProfileModal(true)}>Welcome, {userProfile.name || "Student"} 🖊</h3>
                    </div>

                    {isAibeProfile ? (
                      <>
                        <p>AIBE Preparation</p>

                        <div className="semester-buttons">
                          <button
                            className="buttonstyle"
                            onClick={() =>
                              handleNavigate("/aibe-preparation/syllabus")
                            }
                          >
                            AIBE Syllabus
                          </button>

                          <button
                            className="buttonstyle"
                            onClick={handleAibePracticeNavigate}
                          >
                            AIBE Practice
                          </button>
                        </div>
                      </>
                    ) : (
                      <>
                        <p>Select your Semester</p>

                        <div className="semester-buttons">
                          {(() => {
                            const yearMap = {
                              "1st Year": 1,
                              "2nd Year": 2,
                              "3rd Year": 3,
                              "4th Year": 4,
                              "5th Year": 5,
                            };

                            const year = yearMap[userProfile.year];

                            if (!year) return null;

                            const sem1 = (year - 1) * 2 + 1;
                            const sem2 = sem1 + 1;

                            const degree =
                              userProfile.course === "3YDC"
                                ? "3YDC"
                                : "5YDC";

                            const course =
                              userProfile.course === "3YDC"
                                ? "OU"
                                : encodeURIComponent(userProfile.course);

                            return (
                              <>
                                <button
                                  className="buttonstyle"
                                  onClick={() =>
                                    handleNavigate(
                                      `/notes/${degree}/${course}/${sem1}`
                                    )
                                  }
                                >
                                  Semester {sem1}
                                </button>

                                <button
                                  className="buttonstyle"
                                  onClick={() =>
                                    handleNavigate(
                                      `/notes/${degree}/${course}/${sem2}`
                                    )
                                  }
                                >
                                  Semester {sem2}
                                </button>

                                {(userProfile.year === "5th Year" || userProfile.year === "3rd Year") && (
                                  <button
                                    className="buttonstyle"
                                    onClick={() =>
                                      handleNavigate("/aibe-preparation")
                                    }
                                  >
                                    AIBE
                                  </button>
                                )}
                              </>
                            );
                          })()}
                        </div>
                      </>
                    )}
                  </div>
                ) : (
                  <div className="center">
                    ⚖️ Simple. 😎Smart. 📖Law Notes.
                    <div className="default-hero">
                      📚 Law notes, 📄 PYQs, ⚖ AIBE preparation, 🎓 3YDC & 5YDC — arranged just
                      as per <strong>student needs...✍</strong>
                      <br />
                      <br />
                      ⚖️ Law Simplified, Success Amplified 🎓
                    </div>
                  </div>
                )}
              </div>
            </div>

            <div className="circle">
              <img src={scale} alt="Scale" className="scale-img" />
              <div className="Title">-N.Tejeshwar</div>
            </div>
          </div>
        )}

        <div className="msg-trapezium">
          <div className="msg-trapezium-black"></div>
          <div className="msg-trapezium-white">
            <span className="Hmsg-icn">Loading...</span>
          </div>
        </div>
      </section>
      {showUpdateNotice && (
        <div className="profile-modal-overlay">
          <div className="profile-modal">
            <h2>🚀 We Have an Update!</h2>
            <p>
              Guys, we have an update 🎉 <br />
              Please update your details here for opening the notes quicker than
              before.
            </p>

            <button
              onClick={() => {
                setShowUpdateNotice(false);
                setUserProfile({});
                setShowProfileModal(true);
              }}
            >
              Update
            </button>
          </div>
        </div>
      )}
      {showProfileModal && (
        <div className="profile-modal-overlay">
          <div className="profile-modal">
            <h2>✨Update your Details📝</h2>

            <input
              type="text"
              placeholder="Your Name"
              value={userProfile?.name || ""}
              onChange={(e) =>
                setUserProfile({ ...userProfile, name: e.target.value })
              }
            />

            <select
              value={userProfile?.course || ""}
              onChange={(e) =>
                setUserProfile({
                  ...userProfile,
                  course: e.target.value,
                  year: "",
                })
              }
            >
              <option value="">Select Course</option>
              {courseOptions.map((option) => (
                <option key={option.value} value={option.value}>
                  {option.label}
                </option>
              ))}
            </select>

            {userProfile?.course && userProfile.course !== "AIBE Preparation" && (
              <select
                value={userProfile?.year || ""}
                onChange={(e) =>
                  setUserProfile({ ...userProfile, year: e.target.value })
                }
              >
                <option value="">Select Year</option>

                {(userProfile.course === "3YDC"
                  ? ["1st Year", "2nd Year", "3rd Year"]
                  : ["1st Year", "2nd Year", "3rd Year", "4th Year", "5th Year"]
                ).map((yr, idx) => (
                  <option key={idx} value={yr}>
                    {yr}
                  </option>
                ))}
              </select>
            )}

            <button
              disabled={!isProfileValid}
              style={{
                opacity: !isProfileValid ? 0.6 : 1,
                cursor: !isProfileValid ? "not-allowed" : "pointer",
              }}
              onClick={() => {
                if (!isProfileValid) {
                  alert("Please complete your details.");
                  return;
                }
                localStorage.setItem(
                  "tejcodex_user",
                  JSON.stringify(userProfile),
                );
                setShowProfileModal(false);
              }}
            >
              Save
            </button>
          </div>
        </div>
      )}

      <section className="quickaccess-section">
        <h2 className="quickaccess-heading">Start Your Learning...</h2>
        <div className="book-row">
          {books.map((book, index) => (
            <div
              key={index}
              className={`book-container ${index === 1 ? "book-large" : "book-small"
                } ${flipped[index] ? "flipped" : ""}`}
              onClick={() => handleFlip(index)}
            >
              {/* Spine (always visible, fixed) */}
              <div className="book-spine"></div>

              {/* Front Cover */}
              <div className="book-cover">
                <div className="book-title-rect">
                  <img src={scale} alt="Scale" className="book-icon" />
                  <span className="book-title">{book.title}</span>
                  <span className="book-comment">{book.comment}</span>
                </div>
              </div>

              {/* Inside Page */}
              <div className="book-page">
                <p>{book.content}</p>
              </div>
            </div>
          ))}
        </div>
      </section>

      {previewData && (
        <NotePreview
          subject={
            previewData.semester
              ? previewData.subject
              : `${previewData.subject} (${previewData.course})` // puts course inside subject
          }
          course={""} // blank out
          semester={""} // blank out
          fileName={previewData.fileName}
          onClose={closePreview}
        />
      )}
      <section className="Hfeatures-section">
        <h2 className="Hfeatures-heading">Features of TejCodex...</h2>
        <div
          className="Hgallery-wrapper"
          ref={galleryRef}
          onMouseEnter={stopAutoSlide}
          onMouseLeave={startAutoSlide}
        >
          <div className="Harrow Harrow-left" onClick={prevSlide}></div>

          <div className="Hgallery-container" ref={containerRef}>
            {visibleItems.map((index) => (
              <div
                key={index}
                className={`Hgallery-item ${index === activeIndex ? "active" : ""
                  }`}
                onClick={() => setActiveIndex(index)}
              >
                <div className="Hblock-content">
                  <h3 className="Hblock-heading">{block[index].heading}</h3>
                  <p className="Hblock-text">{block[index].statement}</p>
                </div>
              </div>
            ))}
          </div>

          <div className="Harrow Harrow-right" onClick={nextSlide}></div>
        </div>

        <div className="Hdots">
          {blocks.map((_, index) => (
            <span
              key={index}
              className={`Hdot ${index === activeIndex ? "active" : ""}`}
              onClick={() => setActiveIndex(index)}
            ></span>
          ))}
        </div>

        <p className="Hfeature-statement">{statements[activeIndex]}</p>
      </section>

      <section className="coursewise-section">
        <h2 className="coursewise-heading">Explore Notes by Courses...</h2>
        <div className="course-row">
          {courses.map((course, index) => (
            <div
              key={index}
              className={`course-container ${index === 1 ? "course-large" : "course-small"
                }`}
              style={{ cursor: "pointer" }}
              onClick={course.onClick}
            >
              <div className="course-spine"></div>

              <div className="course-cover">
                <div className="course-title-rect">
                  <img src={scale} alt="Scale" className="course-icon" />
                  <span className="course-title">{course.title}</span>
                  <span className="course-comment">{course.comment}</span>
                </div>
              </div>

              <div className="course-page">
                <p>{course.comment}</p>
              </div>
            </div>
          ))}
        </div>
      </section>

      <section className="home-aibe-section">
        <h2 className="coursewise-heading">AIBE Preparation...</h2>

        <div className="course-row home-aibe-row">

          <div
            className="course-container course-small"
            style={{ cursor: "pointer" }}
            onClick={() =>
              handleNavigate("/aibe-preparation/syllabus")
            }
          >
            <div className="course-spine"></div>

            <div className="course-cover">
              <div className="course-title-rect">
                <img
                  src={scale}
                  alt="Scale"
                  className="course-icon"
                />

                <span className="course-title">
                  AIBE Syllabus
                </span>

                <span className="course-comment">
                  -AIBE Syllabus & Bare Acts Pdf's
                </span>
              </div>
            </div>

            <div className="course-page">
              <p>
                Official AIBE syllabus, subjects and Bare Act
                resources for structured preparation.
              </p>
            </div>
          </div>


          <div
            className="course-container course-large"
            style={{ cursor: "pointer" }}
            onClick={handleAibePracticeNavigate}
          >
            <div className="course-spine"></div>

            <div className="course-cover">
              <div className="course-title-rect">
                <img
                  src={scale}
                  alt="Scale"
                  className="course-icon"
                />

                <span className="course-title">
                  AIBE Practice
                </span>

                <span className="course-comment">
                  -Paper Wise & Random Practice
                </span>
              </div>
            </div>

            <div className="course-page">
              <p>
                Practice AIBE questions through previous
                paper-wise, subject-wise and random practice
                sessions.
              </p>
            </div>
          </div>

        </div>
      </section>

      <section className="Habout-section">
        <h2 className="Habout-heading">About Us...</h2>
        <p className="Habout-subtext">
          “TejCodex is your trusted law companion, offering well-structured
          notes and PYQs designed strictly as per the OU syllabus.
          <br />
          📚✨ Our aim is to simplify learning, so you can focus on
          understanding concepts and succeeding in exams with ease. 🎓⚖️”
        </p>

        <div className="Habout-blocks">
          <div className="Habout-block">
            <img src={scale} alt="Scale" className="Hblock-img" />
            <div className="Hblock-inner">
              <h3>📚 Structured Learning</h3>
              <p>
                Notes are organized course-wise, semester-wise, and subject-wise
                to match the Osmania University syllabus.
              </p>
            </div>
          </div>

          <div className="Habout-block">
            <img src={scale} alt="Scale" className="Hblock-img" />
            <div className="Hblock-inner">
              <h3>📝 Smartly Prepared</h3>
              <p>
                Comprehensive law notes and dedicated AIBE preparation
                resources to support your learning throughout law school and beyond.
              </p>
            </div>
          </div>

          <div className="Habout-block">
            <img src={scale} alt="Scale" className="Hblock-img" />
            <div className="Hblock-inner">
              <h3>🎯 Exam-Focused</h3>
              <p>
                Every note and PYQ is simplified to help you understand quickly
                and perform confidently in exams.
              </p>
            </div>
          </div>

          <div className="Habout-block">
            <img src={scale} alt="Scale" className="Hblock-img" />
            <div className="Hblock-inner">
              <h3>🤝 By Students, For Students</h3>
              <p>
                TejCodex is built to make law study easier, helping every
                learner access free resources anytime, anywhere.
              </p>
            </div>
          </div>
        </div>

        <p className="Habout-final">
          ⚖️ Together, we make law learning simpler and success more achievable.
          🎓
        </p>
      </section>
      <section className="Hcontact-section">
        <h2 className="Hcontact-heading">Contact Us...</h2>
        <p className="Hcontact-subtext">
          We’d love to hear from you! Reach out through any of the channels
          below or drop us a message directly.
        </p>

        <div className="Hcontact-container">
          {/* Left Side */}
          <div className="Hcontact-left">
            <div className="Hcontact-title">
              <h3>TejCodex</h3>
              <img src={scale} alt="Scale" className="Hcontact-logo" />
            </div>

            <ul className="Hcontact-list">
              <li>
                <strong>Email:</strong>{" "}
                <a href="mailto:tejcodex@gmail.com">tejcodex@gmail.com</a>
              </li>
              <li>
                <strong>Support Hours: </strong>{" "}
                <a href="mailto:tejcodex@gmail.com">
                  Mon–Fri, 9:00 AM – 6:00 PM IST
                </a>
              </li>

              <li>
                <strong>Follow Us on WhatsApp Channel:</strong>{" "}
                <a
                  href="https://whatsapp.com/channel/0029Vb6pHKfFCCochOVJVm2a"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  TejCodex
                </a>
              </li>
            </ul>

            <p className="Hcontact-text">
              🔎 If you find any mistakes or 📖 missing topics in the notes,
              kindly reach out to us. 📩 Your feedback 💡 helps us improve and
              serve law students 🎓 better! 🤝
            </p>
          </div>

          {/* Right Side */}
          {/* Right Side */}
          <div className="Hcontact-right">
            <div className="Hform-heading">
              <h3>Contact Form</h3>
              <img src={scale} alt="Scale" className="Hcontact-logo" />
            </div>

            <form className="Hcontact-form" onSubmit={handleSubmit}>
              <input
                type="text"
                name="name"
                placeholder="Your Name"
                className="Hform-input"
                value={formData.name}
                onChange={handleChange}
                required
              />

              <input
                type="email"
                name="email"
                placeholder="Your Email"
                className="Hform-input"
                value={formData.email}
                onChange={handleChange}
                required
              />

              <textarea
                name="message"
                placeholder="Your Message"
                className="Hform-textarea"
                value={formData.message}
                onChange={handleChange}
                required
              ></textarea>

              <button type="submit" className="Hform-button" disabled={loading}>
                {loading ? "Sending..." : "Submit"}
              </button>

              {success && (
                <p className="Hsuccess-msg">Message sent successfully! 🎉</p>
              )}
              {error && (
                <p className="Herror-msg">
                  Failed to send message ❌ Try again.
                </p>
              )}
            </form>
          </div>
        </div>
      </section>
      <footer className="Hfooter-section">
        <div className="Hfooter-top">
          <img src={scale} alt="Scale" className="Hfooter-logo" />
          <span className="Hfooter-title">TejCodex.com</span>
          <span className="Hfooter-rights">© 2025 All rights reserved.</span>
        </div>

        <div className="Hfooter-links">
          <a href="/">Home</a> |<a href="/notes"> Notes</a> |
          <a href="/pyqs"> PYQs</a> |<a href="/aibe-preparation"> AIBE</a> |<a href="/all-notes"> Index of All Notes</a> |
          <a href="/about"> About Us</a> |
          <a href="/contact"> Contact Us</a>
        </div>
      </footer>
    </div>
  );
}

export default Home;
